import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Waveform, LockKey } from "@phosphor-icons/react";

const ResetPassword = () => {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const token = params.get("token") || "";
  const [pwd, setPwd] = useState("");
  const [pwd2, setPwd2] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pwd !== pwd2) { toast.error("Les mots de passe ne correspondent pas"); return; }
    if (pwd.length < 6) { toast.error("Minimum 6 caractères"); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pwd });
      toast.success("Mot de passe mis à jour. Connectez-vous !");
      nav("/login");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Lien invalide ou expiré");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center p-6">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-2 mb-10 justify-center">
          <Waveform weight="fill" size={28} className="text-[#E11D48]" />
          <span className="font-display font-black text-2xl">XooKmédia</span>
        </Link>

        <div className="bg-[#0f0f10] border border-white/10 rounded-2xl p-8">
          <div className="w-12 h-12 rounded-xl bg-[#E11D48]/15 flex items-center justify-center mb-5">
            <LockKey weight="duotone" size={26} className="text-[#E11D48]" />
          </div>
          <h1 className="font-display font-black text-3xl mb-2">Nouveau mot de passe</h1>
          <p className="text-zinc-400 text-sm mb-8">Choisissez un mot de passe sécurisé (6 caractères min.)</p>

          {!token ? (
            <p className="text-red-400">Lien invalide — token manquant.</p>
          ) : (
            <form onSubmit={submit} className="space-y-5">
              <div>
                <Label htmlFor="pwd" className="text-zinc-300">Nouveau mot de passe</Label>
                <Input data-testid="reset-password" id="pwd" type="password" required minLength={6} value={pwd}
                  onChange={(e) => setPwd(e.target.value)}
                  className="mt-2 bg-black/40 border-white/10 text-white" />
              </div>
              <div>
                <Label htmlFor="pwd2" className="text-zinc-300">Confirmer</Label>
                <Input data-testid="reset-password-confirm" id="pwd2" type="password" required minLength={6} value={pwd2}
                  onChange={(e) => setPwd2(e.target.value)}
                  className="mt-2 bg-black/40 border-white/10 text-white" />
              </div>
              <Button data-testid="reset-submit" type="submit" disabled={loading}
                className="w-full bg-[#E11D48] hover:bg-[#BE123C] text-white">
                {loading ? "Mise à jour..." : "Mettre à jour"}
              </Button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
